import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { purchaseInvoicesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const purchaseInvoicesRouteMetadata: IRouteMetadataObj<
  typeof purchaseInvoicesRoutesObj
> = {
  list: {
    title: "purchaseManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/purchaseManagement/purchaseInvoices/table/page"),
    mode: "index",
    type: "main",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "purchaseManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/purchaseManagement/purchaseInvoices/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
    pageState: { noPadding: true, actionType: "back" },
  },
  view: {
    title: "purchaseManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/purchaseManagement/purchaseInvoices/view/page"),
    mode: "view",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
    pageState: { actionType: "back", noPadding: true },
  },
  debtPayment: {
    title: "purchaseManagement.debtPayment.title",
    description: "empty",
    lazy: () =>
      import("@/pages/purchaseManagement/purchaseInvoices/debtPayment/view/page"),
    mode: "view",
    type: "inner",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  viewPayment: {
    title: "purchaseManagement.viewPayment.title",
    description: "empty",
    lazy: () =>
      import("@/pages/purchaseManagement/purchaseInvoices/viewPayments/table/page"),
    mode: "view",
    type: "inner",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  returnGoods: {
    title: "purchaseManagement.returnGoods.title",
    description: "empty",
    lazy: () => import("@/pages/purchaseManagement/returnGoods/page"),
    mode: "create",
    type: "inner",
    icon: "TextWrap",
    breadcrumbs: [],
    permission,
    pageState: { noPadding: true, actionType: "back" },
  },
};

export const purchaseInvoicesRoutes = createRoute<
  typeof purchaseInvoicesRoutesObj
>(purchaseInvoicesRoutesObj, purchaseInvoicesRouteMetadata);
